// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
  display: flex;
  justify-content: space-between;
}
.modal-body{
  min-width: 720px;
}
#classTrainingWeeks{
  width: 190px;
  margin-right: 0px;
}

.table-list {
  border: 1px solid #c1bebe;
}

:host ::ng-deep .ag-body-viewport {
  /* border-left: 1px solid #dae2e8;
  border-right: 1px solid #dae2e8;
  border-bottom: 1px solid #dae2e8; */
}

:host ::ng-deep .training-weeks-input .p-inputnumber-input {
  font-size: 15px;
  height: 40px;
}

.update-table-btn {
  margin-left: 8px;
}

.flex-grow-1 .update-table-btn ::ng-deep .btn {
  margin-top: -5px;
}

:host ::ng-deep .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value){

}

:host ::ng-deep .error-message {
  font-size: 13px;
}

:host ::ng-deep .info-message {
  font-size: 13px;
  color: #6c757d;
  font-style: italic;
}

:host ::ng-deep #name {
  width: 310px;
  display: block;
}

:host ::ng-deep #name:focus {
  border-color: #007cbe;
  outline: none;
}

:host ::ng-deep .wfm-textbox .valid-input:not(:focus),
:host ::ng-deep wfm-textbox .valid-input:not(:focus),
:host ::ng-deep .wfm-textbox .invalid-input:not(:focus),
:host ::ng-deep wfm-textbox .invalid-input:not(:focus) {
  border: solid 1px #ced4da !important;
}

wfm-plan-loading-overlay{
  top: 0;
  bottom: 0;
  position: absolute;
  left: -1px;
  right: 0;
  background: #00000014;
  z-index: 2;
}

::ng-deep .popover.delete-popup {
  max-width: 350px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/new-hire/learning-curve-dialog/learning-curve-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal-footer {\n  display: flex;\n  justify-content: space-between;\n}\n.modal-body{\n  min-width: 720px;\n}\n#classTrainingWeeks{\n  width: 190px;\n  margin-right: 0px;\n}\n\n.table-list {\n  border: 1px solid #c1bebe;\n}\n\n:host ::ng-deep .ag-body-viewport {\n  /* border-left: 1px solid #dae2e8;\n  border-right: 1px solid #dae2e8;\n  border-bottom: 1px solid #dae2e8; */\n}\n\n:host ::ng-deep .training-weeks-input .p-inputnumber-input {\n  font-size: 15px;\n  height: 40px;\n}\n\n.update-table-btn {\n  margin-left: 8px;\n}\n\n.flex-grow-1 .update-table-btn ::ng-deep .btn {\n  margin-top: -5px;\n}\n\n:host ::ng-deep .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value){\n\n}\n\n:host ::ng-deep .error-message {\n  font-size: 13px;\n}\n\n:host ::ng-deep .info-message {\n  font-size: 13px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n:host ::ng-deep #name {\n  width: 310px;\n  display: block;\n}\n\n:host ::ng-deep #name:focus {\n  border-color: #007cbe;\n  outline: none;\n}\n\n:host ::ng-deep .wfm-textbox .valid-input:not(:focus),\n:host ::ng-deep wfm-textbox .valid-input:not(:focus),\n:host ::ng-deep .wfm-textbox .invalid-input:not(:focus),\n:host ::ng-deep wfm-textbox .invalid-input:not(:focus) {\n  border: solid 1px #ced4da !important;\n}\n\nwfm-plan-loading-overlay{\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  left: -1px;\n  right: 0;\n  background: #00000014;\n  z-index: 2;\n}\n\n::ng-deep .popover.delete-popup {\n  max-width: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
